export default __webpack_public_path__ + "static/media/download.fd1f62b2.svg";